"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { CompanyReviewHeroSummary } from "@/types/companyReview";

const ServiceReviewHeroSummaryContext = createContext<CompanyReviewHeroSummary | null>(null);

export function ServiceReviewHeroSummaryProvider({
	initialSummary,
	children,
}: {
	initialSummary: CompanyReviewHeroSummary | null;
	children: ReactNode;
}) {
	return (
		<ServiceReviewHeroSummaryContext.Provider value={initialSummary}>
			{children}
		</ServiceReviewHeroSummaryContext.Provider>
	);
}

export function useServiceReviewHeroSummary() {
	return useContext(ServiceReviewHeroSummaryContext);
}
